import styled from 'styled-components'
import { Row } from 'antd'

const AntRowStyled = styled(Row)``

export default AntRowStyled
